<template>
  <v-dialog
    v-if="isVisible"
    v-model="isVisible"
    :fullscreen="isMobile"
    :hide-overlay="isMobile"
    max-width="600px"
  >
    <v-card class="pa-0 ma-0 px-2 py-2">
      <v-container
        class="pa-0 d-flex justify-space-between"
        :class="{ 'pa-5': isMobile }"
      >
        <v-icon class="pa-0 ma-0" @click="Close()">mdi-close</v-icon>
      </v-container>

      <v-card-title>{{ title }}</v-card-title>

      <v-card-text>
        <v-simple-table class="text-center">
          <thead>
            <tr>
              <th class="text-center">{{ $t("of") }}</th>
              <th class="text-center">{{ $t("until") }}</th>
              <th class="text-center">{{ $t("tax") }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in fromData" :key="item.id">
              <td>{{ numberFormat(item.from) }}</td>
              <td>{{ formatTo(item.to) }}</td>
              <td>{{ formatTax(item.tax) }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CommandmentsDialog",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fromData: [
        { id: 1, from: 0, to: 400000000, tax: "معاف" },
        { id: 2, from: 400000000, to: 800000000, tax: 10 },
        { id: 3, from: 800000000, to: 1000000000, tax: 15 },
        { id: 4, from: 1000000000, to: 1200000000, tax: 20 },
        { id: 5, from: 1200000000, to: 1400000000, tax: 25 },
        { id: 6, from: 1400000000, to: "∞", tax: 30 },
      ],
    };
  },
  watch: {
    isVisible(newVal) {
      if (!newVal) {
        this.$emit("CloseDialog");
      }
    },
  },
  methods: {
    Close() {
      this.$emit("CloseDialog");
    },
    numberFormat(value) {
      return this.$numberFormat(value);
    },
    formatTo(value) {
      return value === "∞" ? value : this.numberFormat(value);
    },
    formatTax(value) {
      return value === "معاف" ? value : `${value} ${this.$t("percent")}`;
    },
  },
};
</script>
